/**
 * Lightweight markdown to HTML parser for EULA content
 * Handles: headings, bold, lists, blockquotes, horizontal rules
 */

export function parseMarkdownToHtml(markdown: string): string {
  if (!markdown || typeof markdown !== 'string') {
    console.warn('Invalid markdown input:', markdown);
    return '';
  }

  try {
    let html = markdown
      // Escape HTML entities
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

    // Horizontal rules (--- on its own line)
    html = html.replace(/^---$/gm, "<hr/>");

    // Headings
    html = html.replace(/^### (.+)$/gm, "<h3>$1</h3>");
    html = html.replace(/^## (.+)$/gm, "<h2>$1</h2>");
    html = html.replace(/^# (.+)$/gm, "<h1>$1</h1>");

    // Bold
    html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");

    // Blockquotes (lines starting with &gt;)
    html = html.replace(/^&gt; (.+)$/gm, "<blockquote>$1</blockquote>");

    // Unordered list items (- item)
    html = html.replace(
      /(^- .+(?:\n- .+)*)/gm,
      (match) => {
        const items = match
          .split("\n")
          .map((line) => `<li>${line.replace(/^- /, "")}</li>`)
          .join("");
        return `<ul>${items}</ul>`;
      }
    );

    // Indented list items (  - item, used inside blockquotes/sub-items)
    html = html.replace(
      /(^ {2,}- .+(?:\n {2,}- .+)*)/gm,
      (match) => {
        const items = match
          .split("\n")
          .map((line) => `<li>${line.replace(/^\s+- /, "")}</li>`)
          .join("");
        return `<ul>${items}</ul>`;
      }
    );

    // Wrap remaining plain-text lines in <p> tags
    html = html
      .split("\n\n")
      .map((block) => {
        const trimmed = block.trim();
        if (!trimmed) return "";
        if (/^<(h[1-3]|ul|ol|hr|blockquote)/.test(trimmed)) return trimmed;
        return `<p>${trimmed.replace(/\n/g, "<br/>")}</p>`;
      })
      .join("\n");

    return html;
  } catch (error) {
    console.error('Error parsing markdown:', error);
    return markdown; // Return original content as fallback
  }
}
